import * as API from './API'

export default {

    //파일 업로드
    async fileUpload(args) {
        let parameters = {
            method: 'POST',
            data: args.formData,
            path: '/api/files/' + args.prefix,
            params: {}
        }
        const apiResponse = await API.fileUploadRequest(parameters)
        return apiResponse
    },

    //파일 다운로드
    downloadFile(fileurl, filename) {
        let href = API.fileHost + '/p/api/files/download?fileUrl=' + fileurl + '&fileName=' + encodeURI(filename);
        window.open(href, '_blank');
    },

    //서버 내부 파일 다운로드
    downloadLocalFile(fileurl, filename){
        API.downloadLocalFile(fileurl, filename)
    },

    //가이드 파일 정보 조회
    async getReferenceFileInfo(fileType) {
        let parameters = {
            method: 'GET',
            path: '/p/api/files/',
            params: {
                'fileType': fileType
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    //가이드 파일 정보 조회
    async getReferenceCategoryFileInfo(fileType) {
        let parameters = {
            method: 'GET',
            path: '/p/api/files/category',
            params: {
                'fileType': fileType
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    }

}



// WEBPACK FOOTER //
// ./src/service/fileAPI.js